var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedTagName,_vm._g({tag:"component",class:_vm.classes,attrs:{"disabled":_vm.modActive,"href":_vm.to,"target":"_blank","type":"button"}},_vm.inputListeners),[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }